import {HttpClient, provideHttpClient, withInterceptors} from '@angular/common/http';
import {ApplicationConfig, importProvidersFrom} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {provideRouter} from '@angular/router';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {NZ_I18N, en_US} from 'ng-zorro-antd/i18n';
import {NzMessageService} from 'ng-zorro-antd/message';
import {NzModalService} from 'ng-zorro-antd/modal';
import {routes} from './app.routes';
import {HttpLoaderFactory} from './core/helpers/http-loader-factory';
import {TokenInterceptor} from './core/interceptor/token.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes,
      // withDebugTracing(),
    ),
    NzModalService,
    NzMessageService,
    provideHttpClient(),
    importProvidersFrom([BrowserModule, BrowserAnimationsModule]),
    provideHttpClient(
      withInterceptors([TokenInterceptor]),
    ),
    importProvidersFrom(TranslateModule.forRoot({
      defaultLanguage: 'en',
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),),
    {
      provide: NZ_I18N,
      useValue: en_US
    },
  ]
};
